import React, { FC } from 'react'
import useDataSharingAccess from '../../hooks/access/useDataSharingAccess'
import PageNotFound from '../../containers/PageNotFound'


interface Props {
  children: React.ReactNode
}

const DataSharingGuard: FC<Props> = ({ children }) => {
  const {
    canAccess,
    isLoading
  } = useDataSharingAccess()

  if (isLoading) {
    return null
  }

  if (!canAccess) {
    return <PageNotFound />
  }

  return <>{children}</>
}

export default DataSharingGuard